import { FLOOR_PLAN_ROOM_ACTIVE_RGB } from "../constants";
import type { BuildRoomsOverlay } from "./types";

export const buildRoomsOverlay: BuildRoomsOverlay = ({
  rooms,
  selectedRoomId = null,
  isInteractive = false,
}) => {
  if (rooms.length === 0) return null;
  const hasSelection = selectedRoomId !== null;
  // Inside a room only that room is drawn, so no other outline crosses its elements
  const visibleRooms = hasSelection
    ? rooms.filter((room) => room.id === selectedRoomId)
    : rooms;

  return {
    polygons: visibleRooms.map((room) => ({
      id: String(room.id),
      points: room.points,
      rgb: FLOOR_PLAN_ROOM_ACTIVE_RGB,
      label: hasSelection ? undefined : room.name,
      isSelected: room.id === selectedRoomId,
      isDraft: false,
    })),
    hoverPosition: null,
    isDrawing: false,
    isInteractive,
    isEditable: false,
    selectedPointId: null,
  };
};
